
const Slidewebsite = () => {
  return <div className="h-[95vh] w-screen overflow-hidden">
    <iframe src="https://docs.google.com/presentation/d/e/2PACX-1vQdrY1yJbWxYxx-lMhuHvSNEFcZ3J8aOgQQjJtn1Sv9SdkvuvHKF2SJCqIqxqzykFccSa5J73qWlhIE/embed?start=false&loop=false&delayms=60000" frameborder="0" className="h-screen w-full" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true"></iframe>
  </div>
}

export default Slidewebsite
